import { ThemeProps } from 'src/hook/useUser'
import { ComponentName } from 'src/utils/datahubDefaultEvent'

export type UserProfileContextProps = {
  visible: boolean
  isSessionUserProfile: boolean
  loggedUserUcode?: string
  userUcode?: string
  arrivedFrom?: ComponentName
  onClose: () => void
  onOpen: (
    event: React.MouseEvent | React.KeyboardEvent,
    userUcode?: string,
    callback?: () => void
  ) => void
}

export type UserProfileProviderProps = {
  token: string
  theme: ThemeProps
  children: React.ReactNode
  loggedUserUcode?: string
  locale?: string
}

export type OpenProfileEvent = CustomEvent & {
  detail: {
    ucode: string
    componentName?: ComponentName
  }
}

export enum EventName {
  OPEN_PROFILE = 'OPEN_PROFILE',
  CLOSE_PROFILE = 'CLOSE_PROFILE'
}
